import Route from 'cio/routes/base';

export default class LoadingRoute extends Route {
  scrollOnActivate = false;
}
